
import React, { useEffect, useState } from 'react';
import Header from './Header';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, FormHelperText, Table, TableRow, TableBody, TableCell, TableContainer, TableHead, Paper, Modal, Box, TablePagination, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Swal from 'sweetalert2';
import apiSafibc from '../../axios/axios';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useLoginStore } from '../../store/zustend';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';


const styleCi = {
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%',
    maxHeight: '80vh', // Limita altura al 80% de la pantalla
    overflowY: 'auto', // Scroll vertical si se excede
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Presentacion = () => {

    const [nombreContacto, setNombreContacto] = useState('')
    const [emailContacto, setEmailContacto] = useState('')
    const [telefonoContacto, setTelefonoContacto] = useState('')
    const [textoContacto, setTextoContacto] = useState('')
    const [tipoAhorro, setTipoAhorro] = useState('')
    const [tipoAhorros, setTipoAhorros] = useState([])
    const [ahorro, setAhorro] = useState('')
    const [comienzoAhorro, setComienzoAhorro] = useState('')
    const [comienzaContrato, setComienzaContrato] = useState()
    const [simuladorSubmited, setSimuladorSubmited] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [pagosSimulados, setPagosSimulador] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [simuladorSumaAhorro, setSimuladorSumaAhorro] = useState(0)
    const [simuladorRendimiento, setSimuladorRendimiento] = useState(0)
    const [simuladorTotal, setSimuladorTotal] = useState(0)
    const [circleLoad, setCircleLoad] = useState(false)

    const { loginStore } = useLoginStore()

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // regresar a la primera página
    };

    const navigation = (text, navHeigth) => {
        const sectionRef = document.getElementById(text);
        if (sectionRef) {

            const componente = document.getElementById(text).offsetTop;

            window.scrollTo({
                top: componente - navHeigth,
                behavior: 'smooth',
            });
        }
    }

    const enviarCorreoInfo = () => {

        //enviar formulario de contacto

        let key = ''
        if (!nombreContacto) key = 'nc'
        if (!telefonoContacto || !emailContacto) key = 'tec'
        if (!textoContacto) key = 'tc'

        let mensaje = ''
        switch (key) {
            case 'nc':
                mensaje = 'Tu nombre es necesario para poder pedir informacion!'
                break;
            case 'tec':
                mensaje = 'Tu telefono es necesario para poder pedir informacion!'
                break;
            case 'tc':
                mensaje = 'Tus preguntas son necesarias para poder pedir informacion!'
                break;
        }

        if (mensaje) {
            return Swal.fire({
                icon: 'info',
                title: 'Opss',
                text: mensaje
            })
        }

        const enviarCorreo = async () => {

            try {

                const jInfoContacto = {
                    nombreContacto,
                    telefonoContacto,
                    textoContacto,
                    emailContacto
                }

                const response = await apiSafibc.post('/presentacion/enviar-correo-info-contacto', jInfoContacto, {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })


                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena',
                    text: response.data.mensaje
                })

                setNombreContacto('')
                setTelefonoContacto('')
                setEmailContacto('')
                setTextoContacto('')

            } catch (error) {
                console.log(error)
                Swal.fire({
                    icon: 'info',
                    title: 'Opss',
                    text: 'Ocurrio un porblema, vuelva a intentarlo!'
                })
            }

        }

        enviarCorreo()

        //correo: crear correo administracion@safibc.net
        //Safibc123.

    }

    const obtenerTipoAhorros = async () => {

        try {
            const obtener_tipo_ahorros = await apiSafibc('/navegacion/obtener-tipo-ahorros', {
                headers: {
                    'XP1-K3Y': `S4f1Vc`,
                    'Accept': 'application/x-www-form-urlencoded',
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })

            setTipoAhorros(obtener_tipo_ahorros.data)
        } catch (error) {
            let msg_error = ''
            if (error.response) {
                if (error.response.data.mensaje) {
                    msg_error = error.response.data.mensaje
                } else {
                    msg_error = 'Ocurrió un error al obtener tipo de ahorros, volver a cargar pagina por favor!'
                }
            }
            //mensaje de toastify
            toast.error(msg_error, toast_config)
        }
    }

    useEffect(() => {
        obtenerTipoAhorros()
    }, [])

    const simularAhorro = () => {
        setCircleLoad(true)
        setSimuladorSubmited(true);

        const jSimularAhorro = {
            id_ahorro: tipoAhorro,
            fecha_comienza: comienzaContrato,
            cantidad_ahorrar: ahorro,
            cantidad_inicial: comienzoAhorro
        }

        const simularAhorro = async () => {

            try {

                const simular = await apiSafibc.post('/presentacion/simular-ahorro', jSimularAhorro, {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                //abrir modal con informacion
                setPage(0)
                setPagosSimulador(simular.data.pagos)
                setSimuladorSumaAhorro(simular.data.suma_ahorro)
                setSimuladorRendimiento(simular.data.rendimiento)
                setSimuladorTotal(simular.data.total)
                setCircleLoad(false)
                setTimeout(() => {
                    setOpenModal(true);
                }, 0);

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al simular ahorro, volver a intentarlo!'
                    }
                }
                //mensaje de toastify
                setCircleLoad(false)
                toast.error(msg_error, toast_config)
            }

        }

        simularAhorro()
    }

    function formatoMonedayLetra(value) {
        const formatter = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2
        })
        return `${formatter.format(value)} MXN`
    }

    return (
        <div>
            <Header eventHandler={navigation} />

            <div className='container-fluid m-0 p-0 bg-presentacion' id='inicio'>
                <p className='text-white p-presentacion font-lato'>Salud Financiera</p>
            </div>

            <div className='container-fluid py-5 bg-light border-bottom'>
                <div className='container '>
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-md-5 mb-2'>
                            <img src="/img/img1.jpg" alt="" className='img-fluid shadow rounded' />
                        </div>
                        <div className='col-md-5 '>
                            <h3 className='fw-bold'>Tu dinero, en buenas manos.</h3><br />
                            <span className='text-justify' style={{ fontSize: '18px' }}>Administramos tus ahorros con responsabilidad, confianza y total transparencia.
                                Construye tu futuro financiero con nosotros. </span>

                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-5 bg-white border-bottom' id='acercade'>
                <div className='container '>
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-md-12 mb-2'>
                            <h2 className='text-center fw-bold'>Acerca de</h2>
                        </div>
                        <div className='col-md-5 '>
                            <h3 className='fw-bold'>Evita los errores que frenan tu crecimiento financiero.</h3><br />
                            <span className='text-justify' style={{ fontSize: '18px' }}>En Salud Financiera Integral BC, te ayudamos a cuidar y hacer crecer tus ahorros, evitando los errores más comunes que impiden prosperar.
                                Porque el primer paso hacia la libertad financiera… es dejar de tropezar con lo mismo.</span>
                        </div>
                        <div className='col-md-5 mb-2'>
                            <img src="/img/acercade.jpeg" alt="" className='img-fluid shadow rounded' />
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-5 bg-light border-bottom' id='ahorros'>
                <div className='container '>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-10'>
                            <img src="/img/ahorros.png" alt="" className='img-fluid rounded' />
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-5 bg-white border-bottom' id='simulador'>
                <div className='container'>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-8'>
                            <div className='card shadow border-0'>
                                <div className='card-header text-white fw-bold fs-4 ' style={{ 'background': '#025A8C' }}>
                                    <span><CurrencyExchangeIcon /> Simulador</span>
                                </div>
                                <div className='card-body m-2'>
                                    <div className='row'>
                                        <div className='col-md-10 mb-3'>
                                            <FormControl variant="standard" sx={{ minWidth: '100%' }} error={simuladorSubmited && !tipoAhorro}
                                            >
                                                <InputLabel id="standard-label">Tipo de Ahorro</InputLabel>
                                                <Select
                                                    labelId="standard-label"
                                                    id="select-standard"
                                                    value={tipoAhorro}
                                                    onChange={(e) => setTipoAhorro(e.target.value)}
                                                    label="Tipo de Ahorro"
                                                >
                                                    {tipoAhorros && tipoAhorros.map(ta => (
                                                        <MenuItem value={ta.id_ahorro} key={ta.id_ahorro}>{`${ta.descripcion}`}</MenuItem>
                                                    ))}
                                                </Select>
                                                {simuladorSubmited && !tipoAhorro && (
                                                    <FormHelperText>Este campo es obligatorio</FormHelperText>
                                                )}
                                            </FormControl>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <TextField helperText={simuladorSubmited && !ahorro ? 'Este campo es obligatorio' : ''} error={simuladorSubmited && !ahorro} onChange={(e) => setAhorro(Number(e.target.value))} value={ahorro} type='number' id="standard-basic" style={{ 'width': '100%' }} label="Cantidad a Ahorrar" variant="standard" />
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <TextField helperText={simuladorSubmited && comienzoAhorro == '' && comienzoAhorro == null ? 'Este campo es obligatorio' : ''} error={simuladorSubmited && comienzoAhorro == '' && comienzoAhorro == null} onChange={(e) => setComienzoAhorro(Number(e.target.value))} value={comienzoAhorro} type='number' id="standard-basic" style={{ 'width': '100%' }} label="Cantidad Inicial a Ahorrar" variant="standard" />
                                        </div>
                                        <div className='col-md-12 mb-3'>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker value={comienzaContrato} label='Comienzo de Contrato' variant='standard' onChange={(value) => setComienzaContrato(value)} slotProps={{
                                                    textField: {
                                                        helperText: simuladorSubmited && !comienzaContrato
                                                            ? 'Este campo es obligatorio'
                                                            : 'MM/DD/YYYY',
                                                        variant: 'standard',
                                                        error: simuladorSubmited && !comienzaContrato,
                                                    },
                                                }} />
                                            </LocalizationProvider>
                                        </div>
                                        <div className='col-md-12 mb-3'>
                                            <Button variant='outlined' onClick={simularAhorro} disabled={!tipoAhorro || !ahorro || comienzoAhorro === '' || comienzoAhorro == null || !comienzaContrato || circleLoad}>
                                                {!circleLoad ?
                                                    'Simular'
                                                    :
                                                    <CircularProgress size={25} />
                                                }
                                            </Button>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-5 bg-light border-bottom' id='contacto'>
                <div className='container '>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-6'>
                            <div className='card border-0 shadow'>
                                <div className='card-body'>
                                    <h2 className='text-center fw-bold'><ContactMailIcon /> Contacto</h2>
                                    <form action="" className='row'>
                                        <div className='col-md-12 mb-2 '>
                                            <TextField value={nombreContacto} onChange={(x) => setNombreContacto(x.target.value.toUpperCase())} id="outlined-basic" label="Nombre Completo" variant="standard" style={{ 'width': '100%' }} required />
                                        </div>
                                        <div className='col-md-6 mb-2'>
                                            <TextField value={emailContacto} onChange={(x) => setEmailContacto(x.target.value.toUpperCase())} id="outlined-basic" label="E-mail" variant="standard" style={{ 'width': '100%' }} required />
                                        </div>
                                        <div className='col-md-6 mb-2'>
                                            <TextField value={telefonoContacto} onChange={(x) => setTelefonoContacto(x.target.value.toUpperCase())} id="outlined-basic" label="Teléfono" variant="standard" style={{ 'width': '100%' }} required />
                                        </div>
                                        <div className="col-md-12 mb-2">
                                            <TextField value={textoContacto} onChange={(x) => setTextoContacto(x.target.value.toUpperCase())} multiline rows={2} label="¿Cómo podemos ayudarte?" variant="standard" style={{ 'width': '100%' }} required />
                                        </div>
                                        <div className='col-md-12 mb-2 d-flex justify-content-center'>
                                            <Button variant="contained" style={{ 'width': '50%' }} endIcon={<SendIcon />} onClick={enviarCorreoInfo}>Enviar</Button>
                                        </div>
                                    </form>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div className='container-fluid' style={{ 'backgroundColor': '#025a8c' }}>
                <div className='row'>
                    <div className='col-md-12 m-0 p-0'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6718.194759843955!2d-115.45412822491593!3d32.65685267371405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d771cedc75818d%3A0x600206839af1c9c2!2sWorkaholic!5e0!3m2!1ses!2sus!4v1750736476702!5m2!1ses!2sus" width="100%" height="450" style={{ 'border': '0' }} loading="lazy"></iframe>
                    </div>
                </div>
            </div>

            <div className='container-fluid py-4' style={{ 'backgroundColor': '#025a8c' }}>
                <div className='row d-flex justify-content-center'>
                    <div className='col-md-8 text-center'>
                        <i className="fa-brands fa-facebook fa-2xl m-2 shadow text-light"></i>
                        <i className="fa-brands fa-instagram fa-2xl m-2 shadow text-light"></i>
                    </div>
                </div>
            </div>

            <Modal
                open={openModal} onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleCi}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card  border-0'>
                        <div className='card-header text-center'>
                            <h3>Pagos Ahorro</h3>
                        </div>
                        <div className='card-body m-2'>
                            {/** AGREGAR UNA TRABLA INDEXADA CON LOS CONTRATOS PROXIMOS */}
                            {comienzoAhorro > 0 ?
                                <TextField
                                    inputProps={{
                                        readOnly: true,
                                        style: { fontWeight: 'bold' }
                                    }}
                                    InputLabelProps={{
                                        style: { fontWeight: 'bold' }
                                    }}
                                    variant='standard' className='mb-3' value={formatoMonedayLetra(comienzoAhorro)} label={'Con una cantidad inicial de'} />
                                : null
                            }

                            <TableContainer component={Paper} className='mb-3'>
                                <Table sx={{ minWidth: 700 }} aria-label="customized table" className="animation-layout">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell >
                                                <CalendarMonthIcon />
                                            </StyledTableCell>
                                            <StyledTableCell >
                                                <MonetizationOnIcon />
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {pagosSimulados && pagosSimulados
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((p, i) => (
                                                <StyledTableRow key={i}>
                                                    <StyledTableCell className='fw-bold'>
                                                        {p}
                                                    </StyledTableCell>
                                                    <StyledTableCell className='fw-bold'>
                                                        {formatoMonedayLetra(ahorro)}
                                                    </StyledTableCell>

                                                </StyledTableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    component="div"
                                    count={pagosSimulados.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[5, 10]}
                                    labelRowsPerPage="Registros por página"
                                />
                            </TableContainer>

                            <TextField
                                inputProps={{
                                    readOnly: true,
                                    style: { fontWeight: 'bold' }
                                }}
                                InputLabelProps={{
                                    style: { fontWeight: 'bold' }
                                }}
                                value={simuladorSumaAhorro + ' MXN'} className='m-3' id="standard-basic" style={{ 'width': '25%' }} label="Suma Ahorro" variant="standard" />

                            <TextField
                                inputProps={{
                                    readOnly: true,
                                    style: { fontWeight: 'bold' }
                                }}
                                InputLabelProps={{
                                    style: { fontWeight: 'bold' }
                                }}
                                value={simuladorRendimiento + ' MXN'} className='m-3' id="standard-basic" style={{ 'width': '25%' }} label="Rendimiento" variant="standard" />

                            <TextField
                                inputProps={{
                                    readOnly: true,
                                    style: { fontWeight: 'bold' }
                                }}
                                InputLabelProps={{
                                    style: { fontWeight: 'bold' }
                                }}
                                value={simuladorTotal + ' MXN'} className='m-3' id="standard-basic" style={{ 'width': '25%' }} label="Total" variant="standard" />


                        </div>
                    </div>
                </Box>

            </Modal>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )
}

export default Presentacion
